import {ClassicType} from "../../shared/models/ClassicType";
import {Azienda} from "../../Admin/models/Azienda";

export class ProvaAcquisto {
  prodotto?: string;
  seriale?: string;
  rivenditore?: string;
  brandDesc?: string;
  dataDoc?: string;
  brand?: number;
  acquisto?: number;
  difetto?: number;
  ricevuta?: string;
  id?: number;
  numeroDoc?: any;
  brandObject?: ClassicType;
  difettoObject?: any;
  acquistoObject?: any;
  targhetta?: any;
  targhettaId?: any;
  ricevutaId?: any;
  acquirente?: Azienda;
  modifica?: boolean;
  prodottoObject?: any;
  sedeObject?: any;
  prodottoId?: number;
  stampa?: boolean;
  constructor(acquirente?: Azienda) {
    this.acquirente = acquirente;
  }
}
